const commonAmenities = {
  en: ['Equipped kitchen', 'Wi-Fi', 'Private parking'],
  ru: ['Оборудованная кухня', 'Wi-Fi', 'Частная парковка'],
};

const createGallery = (folder, filenames) => filenames.map(
  (filename) => `/images/apartments/${folder}/${filename}`,
);

const galleries = {
  penthouseRadonic: createGallery('penthouse-radonic', [
    '05.jpg', '10.jpg', '15.jpg', '17.jpg', '20.jpg', '25.jpg', '30.jpg', '35.jpg', '38.jpg',
    '40.jpg', '45.jpg', '50.jpg', '52.jpg', '54.jpg', '55.jpg', '60.jpg', '62.jpg', '63.jpg',
    '65.jpg', '70.jpg', '75.jpg', '80.jpg', '85.jpg', '90.jpg', '220.jpg', '270.jpg', '280.jpg',
  ]),
  horizon3br: createGallery('horizon-3br', [
    '05.jpg', '40.jpg', '50.jpg', '70.jpg', '80.jpg', '100.jpg', '110.jpg', '125.jpg',
    '130.jpg', '135.jpg', '140.jpg', '145.jpg', '150.jpg', '155.jpg', '160.jpg', '165.jpg',
    '170.jpg', '175.jpg', '180.jpg', '185.jpg', '290.jpg', '310.jpg', '340.jpg',
  ]),
  grand3bd: createGallery('grand-3bd', [
    '10.jpg', '20.jpg', '25.jpg', '30.jpg', '33.jpg', '35.jpg', '60.jpg', '70.jpg', '80.jpg',
    '90.jpg', '140.jpg', '145.jpg', '147.jpg', '150.jpg', '155.jpg', '160.jpg', '170.jpg',
    '180.jpg', '200.jpg',
  ]),
  viewEnsuite: createGallery('view-ensuite', [
    '10.jpg', '15.jpg', '20.jpg', '25.jpg', '30.jpg', '35.jpg', '40.jpg', '45.jpg',
    '50.jpg', '55.jpg', '60.jpg', '65.jpg', '70.jpg', '75.jpg', '80.jpg', '85.jpg',
  ]),
  oliveShade: createGallery('olive-shade', [
    '05.jpg', '10.JPG', '15.jpg', '17.jpg', '20.jpg', '25.jpg', '30.jpg', '35.jpg', '40.jpg',
    '45.jpg', '50.jpg', '60.jpg', '65.jpg', '70.jpg', '75.jpg', '80.jpg', '85.jpg', '90.jpg',
    '95.jpg', '100.jpg',
  ]),
  seaView2br: createGallery('sea-view-2br', [
    '05.jpg', '10.jpg', '15.jpg', '17.jpg', '20.jpg', '25.jpg', '30.jpg', '34.jpg', '35.jpg',
    '40.jpg', '45.jpg', '50.jpg', '55.jpg', '58.jpg',
  ]),
};

const residenceCatalog = [
  {
    id: 'residence-01',
    image: galleries.penthouseRadonic[0],
    gallery: galleries.penthouseRadonic,
    name: { en: 'Penthouse Radonić', ru: 'Пентхаус Radonić' },
    category: { en: 'Penthouse with Sveti Stefan island view', ru: 'Пентхаус с видом на остров Святой‑Стефан' },
    description: {
      en: 'A light-filled 163 m² penthouse with panoramic views of the Adriatic, Sveti Stefan island and the mountains. It has two bedrooms, two bathrooms, generous terraces and a spacious living area.',
      ru: 'Светлый пентхаус площадью 163 м² с панорамным видом на Адриатику, остров Святой‑Стефан и горы. В апартаменте две спальни, два санузла, просторные террасы и большая гостиная.',
    },
    specs: {
      en: ['Up to 6 guests', '163 m²', '2 bedrooms', '2 bathrooms'],
      ru: ['До 6 гостей', '163 м²', '2 спальни', '2 санузла'],
    },
    amenities: commonAmenities,
  },
  {
    id: 'residence-02',
    image: galleries.horizon3br[0],
    gallery: galleries.horizon3br,
    name: { en: 'Horizon 3BR', ru: 'Horizon 3BR' },
    category: { en: 'Three-bedroom sea view', ru: 'Три спальни и вид на море' },
    description: {
      en: 'A generous 148 m² apartment for families and groups, with three bedrooms, two bathrooms, an open-plan living room and a sea-facing dining area.',
      ru: 'Просторный апартамент площадью 148 м² для семьи или компании: три спальни, два санузла, объединённая гостиная и обеденная зона с видом на море.',
    },
    specs: {
      en: ['Up to 8 guests', '148 m²', '3 bedrooms', '2 bathrooms'],
      ru: ['До 8 гостей', '148 м²', '3 спальни', '2 санузла'],
    },
    amenities: commonAmenities,
  },
  {
    id: 'residence-03',
    image: galleries.grand3bd[0],
    gallery: galleries.grand3bd,
    name: { en: 'Grand 3BD', ru: 'Grand 3BD' },
    category: { en: 'Three-bedroom apartment', ru: 'Апартамент с тремя спальнями' },
    description: {
      en: 'A spacious 133 m² apartment with three bedrooms, one full bathroom and an additional guest toilet. A broad terrace and generous living area bring the Adriatic into view.',
      ru: 'Просторный апартамент площадью 133 м² с тремя спальнями, полноценным санузлом и дополнительным гостевым туалетом. Большая общая зона и терраса обращены к Адриатике.',
    },
    specs: {
      en: ['Up to 7 guests', '133 m²', '3 bedrooms', '1.5 bathrooms'],
      ru: ['До 7 гостей', '133 м²', '3 спальни', '1,5 санузла'],
    },
    amenities: commonAmenities,
  },
  {
    id: 'residence-04',
    image: galleries.viewEnsuite[0],
    gallery: galleries.viewEnsuite,
    name: { en: 'View & Ensuite', ru: 'View & Ensuite' },
    category: { en: 'Two-bedroom sea view', ru: 'Две спальни и вид на море' },
    description: {
      en: 'A bright 67 m² apartment with two bedrooms, two bathrooms, a sea-facing living room and a private terrace — comfortable for a family or two couples.',
      ru: 'Светлый апартамент площадью 67 м² с двумя спальнями, двумя санузлами, гостиной с видом на море и отдельной террасой — для семьи или двух пар.',
    },
    specs: {
      en: ['Up to 6 guests', '67 m²', '2 bedrooms', '2 bathrooms'],
      ru: ['До 6 гостей', '67 м²', '2 спальни', '2 санузла'],
    },
    amenities: commonAmenities,
  },
  {
    id: 'residence-05',
    image: galleries.oliveShade[0],
    gallery: galleries.oliveShade,
    name: { en: 'Olive Shade', ru: 'Olive Shade' },
    category: { en: 'Two-bedroom garden terrace', ru: 'Две спальни и тихая терраса' },
    description: {
      en: 'A quiet 126 m² apartment with two bedrooms, two bathrooms, an atrium, greenery and a sheltered terrace with a projector — cool, private and well suited to relaxed family stays.',
      ru: 'Тихий апартамент площадью 126 м² с двумя спальнями, двумя санузлами, атриумом, зелёным окружением и защищённой террасой с проектором — для спокойного семейного отдыха.',
    },
    specs: {
      en: ['Up to 4 guests', '126 m²', '2 bedrooms', '2 bathrooms'],
      ru: ['До 4 гостей', '126 м²', '2 спальни', '2 санузла'],
    },
    amenities: commonAmenities,
  },
  {
    id: 'residence-06',
    image: galleries.seaView2br[0],
    gallery: galleries.seaView2br,
    name: { en: '2BR Sea View', ru: '2BR Sea View' },
    category: { en: 'Two-bedroom sea view', ru: 'Две спальни и вид на море' },
    description: {
      en: 'An 80 m² sea-view apartment with two bedrooms, one full bathroom and an additional guest toilet, a full kitchen and a terrace above the coast.',
      ru: 'Апартамент площадью 80 м² с видом на море, двумя спальнями, полноценным санузлом и дополнительным гостевым туалетом, кухней и террасой над побережьем.',
    },
    specs: {
      en: ['Up to 6 guests', '80 m²', '2 bedrooms', '1.5 bathrooms'],
      ru: ['До 6 гостей', '80 м²', '2 спальни', '1,5 санузла'],
    },
    amenities: commonAmenities,
  },
];

export const residenceDisplayOrder = Object.freeze([
  'residence-01',
  'residence-02',
  'residence-03',
  'residence-06',
  'residence-04',
  'residence-05',
]);

export const residences = residenceDisplayOrder.map(
  (residenceId) => residenceCatalog.find((residence) => residence.id === residenceId),
);

export function getResidence(residenceId) {
  return residences.find((residence) => residence.id === residenceId);
}
